<template>
    <div id="modalcontact" class="modal">
        <div class="modal-content">
            <h4><strong>Contactez-moi !</strong></h4>
            <p>Contactez-moi directement, ou laissez votre mail pour que je vous contacte.</p>
            <i class="fas fa-at "></i> pl.despaigne@gmail.com
            <div class="row valign-wrapper">
              <div class="col m8 input-field">
                <input type="text" id="customer-email-1" class="validate" required pattern=".+@.+\..+">
                <label for="customer-email-1">Entrez votre adresse e-mail</label>
                <span class="helper-text" data-error="Adresse email non valide" data-success="Ok"></span>
              </div>
              <div class="col m4">
                <button class="modal-close btn waves-effect waves-light cta-btn send-email-btn" type="submit" name="action" data-input="customer-email-1">Envoyez
                  <i class="material-icons right">send</i>
                </button>
              </div>
            </div>
        </div>
        <div class="modal-footer">
            <span class="modal-close waves-effect waves-green btn-flat">Fermer<i class="material-icons right">close</i></span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Modalcontact'
}
</script>

<style scoped>
strong {
    font-weight: bolder;
}
/* label color */
.input-field label {
  color: #1d263b;
}
/* label focus color */
.input-field input[type=text]:focus + label {
  color: #e84855;
}
.input-field input[type=text] {
  border-bottom: 1px solid #1d263b;
}
/* label underline focus color */
.input-field input[type=text]:focus {
  border-bottom: 1px solid #e84855;
  box-shadow: 0 1px 0 0 #e84855;
}
.cta-btn {
    background-color: #e84855;
}
</style>



// WEBPACK FOOTER //
// src/components/Modalcontact.vue